<template>
    <div>
        <headers ref="headers"></headers>
        <div class="top-bg">
            <div class="title">海量方案，供你参考</div>
            <el-input class="search-input" placeholder="请输入您要搜索的内容" clearable v-model="title">
                <template slot="append">
                    <el-button @click="searckTitle" type="primary"><i class="el-icon-search"></i> 搜索</el-button>
                </template>
            </el-input>
        </div>
        <div class="hall-content">
            <div class="tab">
                <div class="flex fd align-center" @click="typeTab(index)" style="margin-right: 60px;"
                    v-for="(item, index) in tabList2" :key="index">
                    <a class="tab2-item" :style="{ color: activeIndex == index ? '#3D82F6' : '#838B93' }"
                        style="cursor:pointer">{{
                            item.label }}</a>
                    <div v-if="activeIndex == index" class="active2-line"></div>
                </div>
            </div>
            <caseList v-on:loginStatus="loginStatus" ref="caseList" v-if="activeIndex == 1"></caseList>
            <workResultsList v-on:loginStatus="loginStatus" ref="workResultsList" v-else-if="activeIndex == 0">
            </workResultsList>
            <studyList v-on:loginStatus="loginStatus" ref="studyList" v-else></studyList>
        </div>
        <footers></footers>

    </div>
</template>
<script>
import headers from '@/components/header.vue'
import footers from '@/components/footer.vue'
import caseList from './components/list/case.vue'
import workResultsList from './components/list/work_results.vue'
import studyList from './components/list/study.vue'
export default {
    components: { caseList, workResultsList, studyList, headers, footers },
    data() {
        return {

            tabList2: [{
                url: '',
                label: '工作成果库'
            }, {
                url: '',
                label: '监测周期库'
            }, {
                url: '',
                label: '学习充电库'
            }],
            tabIndex: 0,
            activeIndex: 0,
            title: ''

        }
    },
    created() {
        this.activeIndex = this.$route.query.channel || 0
    },
    methods: {
        typeTab(index) {
            this.activeIndex = index
        },
        searckTitle() {
            if (this.activeIndex == 0) {
                this.$refs.workResultsList.searchTitle(this.title);
            } else if (this.activeIndex == 1) {
                this.$refs.caseList.searchTitle(this.title);
            } else {
                this.$refs.studyList.searchTitle(this.title);
            }

        },
        loginStatus(e) {
            this.$refs.headers.setLoginVisible(e);
        }
    }
}
</script>
<style>
.top-bg {
    width: 100%;
    height: 324px;
    background-image: url('../../assets/images/article-bg.jpg');
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.top-bg .title {
    font-size: 40px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    padding-top: 124px;
}

.search-input {
    width: 635px;
    height: 56px;
    border: 1px solid #BDD4FF !important;
    border-radius: 8px 8px 8px 8px !important;
    display: flex;
    margin-top: 40px;
}

.search-input .el-input__inner {
    height: 56px !important;
    background: rgba(114, 114, 114, 0.3) !important;
    border-radius: 8px 0px 0px 8px !important;
    opacity: 1 !important;
    border: none;
    font-size: 16px;
    color: #fff;

}

.search-input .el-input-group__append {
    width: 106px;
    height: 56px;
    background: #0042EC;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    border: 1px solid #BDD4FF;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #fff;
    font-size: 16px;
}

.hall-content {
    width: 1200px;
    margin: 0 auto;
    margin-top: 27px;
    margin-bottom: 45px;
}

.hall-content .el-menu.el-menu--horizontal {
    border: none;
}

.form-item {
    margin-left: 24px;
}

.fenjie-line {
    width: 1200px;
    height: 0px;
    opacity: 1;
    border: 1px solid #ecf1f5;
    margin: 8px 0 28px 0;
}

.content-title {
    display: flex;
    align-items: center;
}

.content-title .title-line {
    width: 7px;
    height: 24px;
    background: #435696;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
}

.content-title .title {
    font-size: 24px;
    font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
    font-weight: 600;
    color: #000000;
    margin-left: 6px;
}

.a-content {
    margin: 24px 0px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.a-content-item {
    width: 588px;
    height: 119px;
    background: #ffffff;
    opacity: 1;
    border: 1px solid #f1f3f7;
    border-radius: 6px;
    margin-bottom: 25px;
    align-items: center;
    cursor: pointer;
    position: relative;
}

.is-put {
    position: absolute;
    top: -2px;
    left: -2px;
    width: 74px;
    height: 44px;
}

.a-content-img {
    width: 210px;
    height: 119px;
    opacity: 1;
    border-radius: 6px 0 0 6px;
}

.a-content-title {
    width: 299px;
    height: 22px;
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 600;
    color: #242627;
    line-height: 19px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.a-content-con {
    margin: 12px 6px 11px 16px;
}

.a-content-text {
    width: 354px;
    /* height: 64px; */
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #838b93;
    line-height: 1.5;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin-top: 4px;
    margin-bottom: 8px;
}

.a-content-price {
    font-size: 12px;
    color: #297FFF;
}
</style>


// WEBPACK FOOTER //
// src/views/index/index.vue